import React from 'react'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import LRTableBodyUI from '../../../widgets/layout/LRTableBodyUI'
import LRTableRowUI from '../../../widgets/layout/LRTableRowUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import EmptyListUI from '../../../widgets/output/EmptyListUI'
import BadgeUI from '../../../widgets/output/BadgeUI'
import CardUI from '../../../widgets/layout/CardUI'

const ExternalTxnListUI = ({ context, accountNumber, bankTxnList, totalAmount, totalAmountF1,
  crAmountF1Map, drAmountF1Map, 
  onCopyToClipboard, copyToClipboardText, onRefreshClick
}) =>
  <div className='su_recon'>
    <LRTableActionsUI location='top'
      left={
        <ActionLeftUI
          context={context}
          onRefreshClick={onRefreshClick}
          accountNumber={accountNumber}
        />
      }
      right={
        <ActionRightUI
          context={context}
          totalAmount={totalAmount}
          totalAmountF1={totalAmountF1}
        />
      }
    />

    {
      bankTxnList.length === 0 &&
      <EmptyListUI
        context={context}
        createEnabled={false}
        createDisabledMessageLabel='No external transactions'
      />
    }

    {
      bankTxnList.length > 0 &&
      <div>
        <div className='g_flex_h g_m_bottom_50'>
          <span className='g_muted'>This page displays non-Escrow transactions in the nodal account</span>
          <span>{bankTxnList.length} transaction{bankTxnList.length == 1 ? '' : 's'}</span>
        </div>

        <Summary crAmountF1Map={crAmountF1Map} drAmountF1Map={drAmountF1Map} />

        <LRTableBodyUI className='g_m_top_100'>
          {
            bankTxnList.map((bankTxn, i) =>
              <BankTxnRowList key={i} context={context} bankTxn={bankTxn}
                onCopyToClipboard={onCopyToClipboard} copyToClipboardText={copyToClipboardText}
              />
            )
          }
        </LRTableBodyUI>

        {/*
          accountNumber === '007105010733' &&
          <img src='/images/finapp/escc_external.png' />
        */}
      </div>
    }
  </div>

const Summary = ({ crAmountF1Map, drAmountF1Map }) =>
  <CardUI title='Summary'>
    <div className='g_flex_h g_flex_top g_flex_left'>
      <table><tbody>
        {
          Object.entries(crAmountF1Map).map(([name, value]) => (
            <tr key={name}>
              <td>{name}</td>
              <td className='g_text_right'>{value}</td>
            </tr>
          ))
        }
      </tbody></table>
      <table className='g_m_left_100'><tbody>
        {
          Object.entries(drAmountF1Map).map(([name, value]) => (
            <tr key={name}>
              <td>{name}</td>
              <td className='g_text_right'>({value})</td>
            </tr>
          ))
        }
      </tbody></table>
    </div>
    <div className='g_text_right'><i>fd_withdrawal includes interest earned.</i></div>
  </CardUI>

const BankTxnRowList = ({ context, bankTxn, onCopyToClipboard, copyToClipboardText }) =>
  <LRTableRowUI
    context={context} className='g_flex_top'
    left={<BankTxnRowLeftUI context={context} bankTxn={bankTxn}
      onCopyToClipboard={onCopyToClipboard} copyToClipboardText={copyToClipboardText}
    />}
    right={
      <BankTxnRowRightUI bankTxn={bankTxn} />
    }
  />

const BankTxnRowLeftUI = ({ bankTxn, onCopyToClipboard, copyToClipboardText }) =>
  <div className='g_flex_v'>
    <span className=''>
      {bankTxn.transactionDateF}
      <span className='g_muted g_m_left_50'>{bankTxn.iciciTransactionId}</span>
      <span onClick={e => e.stopPropagation()}>
        <CopyToClipboard text={bankTxn.iciciTransactionId}
          onCopy={onCopyToClipboard}>
          <span className='g_m_left_50 g_muted icon icon-clone g_cursor_pointer' />
        </CopyToClipboard>
        {
          copyToClipboardText === bankTxn.iciciTransactionId &&
          <span className='g_m_left_50 g_muted'>copied</span>
        }
      </span>
    </span>
    <span className='g_small'>{bankTxn.particulars}</span>
    {/* <span className='g_muted'>{bankTxn.statusUpdatedBy}</span> */}
  </div>

const BankTxnRowRightUI = ({ bankTxn }) =>
  <div className='g_flex_v g_text_right'>
    <span>{`${bankTxn.amount < 0 ? '(' : ''}` + bankTxn.amountF2 + `${bankTxn.amount < 0 ? ')' : ''}`}</span>
    <span className='g_m_top_25'>
      <BadgeUI label={bankTxn.climeTxnType} />
    </span>
  </div>

const ActionLeftUI = ({ onRefreshClick, accountNumber }) =>
  <div className='g_flex_h'>
    <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
    <span className='g_m_left_100 g_large'><b>Non-Escrow Transactions in {accountNumber}</b></span>
  </div>

const ActionRightUI = ({ totalAmount, totalAmountF1 }) =>
  <div className='g_xxlarge'>
    {totalAmount < 0 ? `(${totalAmountF1})` : totalAmountF1}
  </div>

export default ExternalTxnListUI
